import React, { useEffect, useState } from "react";
import RGL, { WidthProvider, Layouts } from "react-grid-layout";
import { Row, Spin, Col, Card } from "antd";
import { CheckCard } from "@ant-design/pro-components";

import { initialLayout } from "./initialLayout";
import coreFunctions from "src/common/utils/coreFunctions";
import { useStatusStore } from "./StatusStore";
import apiRequest from "src/common/utils/apiRequest";

interface AppointmentStatisticByStatus {
  slug: string;
  name: string;
  icon: string;
  color: string;
  total: number;
}

const AppointmentStatistics = () => {
  const ResponsiveGridLayout = WidthProvider(RGL.Responsive);
  const [layoutLoading, setLayoutLoading] = useState<boolean>(true);
  const [layouts, setLayouts] = useState<Layouts>({});
  const [statistic, setStatistic] = useState<AppointmentStatisticByStatus[]>(
    []
  );
  const { statuses, setStatuses } = useStatusStore();

  useEffect(() => {
    const savedLayout = localStorage.getItem("appointments_dashboard_layout");
    if (savedLayout) {
      const parsedLayout = JSON.parse(savedLayout);
      if (parsedLayout && parsedLayout.lg) {
        setLayouts(parsedLayout);
      }
    } else {
      setLayouts(initialLayout);
    }

    const loadData = async () => {
      setLayoutLoading(true);
      const API_REQUEST = new apiRequest(
        "appointments/statistics/status-wise",
        true
      );
      await API_REQUEST.send(
        {},
        (data: { status: string; data: AppointmentStatisticByStatus[] }) => {
          if (data.status === "success") {
            setStatistic(data.data);
            setLayoutLoading(false);
          }
        }
      );
    };

    loadData();

    setStatistic(statistic);
  }, []);

  const handleStatusClick = (slug: string) => {
    const isSelected = statuses.includes(slug);
    const updatedStatuses = isSelected
      ? statuses.filter((s) => s !== slug)
      : [...statuses, slug];

    setStatuses(updatedStatuses);
  };

  return layoutLoading ? (
    <Row>
      <Col span={24} style={{ textAlign: "center" }}>
        <Spin size="large" />
      </Col>
    </Row>
  ) : (
    <ResponsiveGridLayout
      isDroppable={false}
      className="layout"
      layouts={layouts}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      cols={{ lg: 4, md: 4, sm: 4, xs: 4, xxs: 4 }}
      rowHeight={100}
      isDraggable={false}
      isResizable={false}
      margin={[16, 16]}
      containerPadding={[16, 16]}
    >
      {statistic.map((item, index) => (
        <div key={"kpi" + (index + 1)}>
          <Card>
            <CheckCard
              avatar={coreFunctions.renderIcon(item.icon, {
                style: { fontSize: 32, color: item.color },
              })}
              title={item.name}
              style={{
                width: "100%",
                marginTop: coreFunctions.isMobileDevice() ? -15 : 0,
              }}
              description={item.total ? item.total : "-"}
              checked={statuses.includes(item.slug)}
              onClick={() => handleStatusClick(item.slug)}
            />
          </Card>
        </div>
      ))}
    </ResponsiveGridLayout>
  );
};

export default React.memo(AppointmentStatistics);
